// extracted by mini-css-extract-plugin
export default {"fixedDurationHint":"ExperienceDurationType_fixedDurationHint__-dPL3"};